<script setup lang="ts">
import { Lock } from "@iconoir/vue";

defineOptions({ name: "Forbidden" });

const { t } = useI18n();
const router = useRouter();

function goHome() {
  router.replace("/");
}
</script>

<template>
  <div class="forbidden">
    <div class="forbidden__card">
      <Lock class="forbidden__icon" />
      <h1 class="h3-primary">{{ t("error.forbiddenTitle") }}</h1>
      <p class="text-body-secondary content-neutral-medium">
        {{ t("error.forbiddenBody") }}
      </p>
      <Button variant="primary" size="medium" @click="goHome">
        {{ t("error.backHome") }}
      </Button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.forbidden {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: token("padding-large");
  background: token("color-bg-canvas");

  &__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: token("gap-medium");
    text-align: center;
    max-width: 480px;
    padding: token("padding-xlarge");
    background: token("color-bg-surface");
    border-radius: token("corner-radius-large");
    border: 1px solid token("color-border-neutral-alpha-light-default");
  }

  &__icon {
    width: token("dm-64");
    height: token("dm-64");
    color: token("color-content-neutral-medium");
  }
}
</style>
